import React from 'react';

import MainTextfield from 'components/textfield/MainTextfield';

const LastNameInput = ({ value, onChange, errorMessage }) => {
  return (
    <MainTextfield
      label="Last name"
      value={value}
      fullWidth
      onChange={(e) => onChange(e.target.value)}
      error={!!errorMessage}
      helperText={errorMessage}
    ></MainTextfield>
  );
};

export default LastNameInput;
